"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFeedbackNotification = void 0;
var _icons = require("@ori-ui/icons");
var _react = require("react");
var _types = require("../types");
const useFeedbackNotification = () => {
  const [isFeedbackOpen, setIsFeedbackOpen] = (0, _react.useState)(false);
  const [feedbackNotificationSettings, setFeedbackNotificationSettings] = (0, _react.useState)({
    icon: _icons.Check
  });
  const handleFeedbackOpen = (0, _react.useCallback)(notificationType => {
    switch (notificationType) {
      case _types.FeedbackNotificationType.Replacement:
        setFeedbackNotificationSettings({
          icon: _icons.Replace,
          messageKey: _types.TranslationKey.replaced
        });
        break;
      case _types.FeedbackNotificationType.Reserve:
        setFeedbackNotificationSettings({
          icon: _icons.Delay,
          messageKey: _types.TranslationKey.reserved
        });
        break;
      case _types.FeedbackNotificationType.Subscription:
        setFeedbackNotificationSettings({
          icon: _icons.Subscription,
          messageKey: _types.TranslationKey.subscribed
        });
        break;
      default:
        setFeedbackNotificationSettings({
          icon: _icons.Check
        });
    }
    setIsFeedbackOpen(true);
  }, [setIsFeedbackOpen, setFeedbackNotificationSettings]);
  const handleClose = (0, _react.useCallback)(() => {
    setIsFeedbackOpen(false);
  }, []);
  return {
    feedbackNotificationSettings,
    handleClose,
    handleFeedbackOpen,
    isFeedbackOpen
  };
};
exports.useFeedbackNotification = useFeedbackNotification;